import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceRunnerRemittances_remittances_edges_node_remitter } from "@saleor/remittanceRunner/types/RemittanceRunnerRemittances";
import React from "react";

interface RemittanceRunnerTblColDispatcherProp {
  remitter: RemittanceRunnerRemittances_remittances_edges_node_remitter;
}

export const RemittanceRunnerTblColDispatcher: React.FC<RemittanceRunnerTblColDispatcherProp> = props => {
  const { remitter } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Dispatcher</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => remitter?.id) ? (
          <span>{remitter?.firstName + " " + remitter?.lastName}</span>
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColDispatcher;
